import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { assignRoleToUser } from "../slices/userSlice";

const RoleAssignModal = ({ isOpen, onClose, selectedUser }) => {
  const dispatch = useDispatch();
  const { roles } = useSelector((state) => state.users);
  const [selectedRole, setSelectedRole] = useState("");

  if (!isOpen || !selectedUser) return null;

  const handleAssignRole = async () => {
    if (!selectedRole) return;
    console.log(selectedUser.id);
    console.log(selectedRole);
    await dispatch(assignRoleToUser({ userId: selectedUser.id, roleId: selectedRole }));
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>✖</button>
        <h2>{selectedUser.firstName} üçün rol təyin et</h2>
        <select value={selectedRole} onChange={(e) => setSelectedRole(e.target.value)}>
          <option value="">Rol seçin</option>
          {roles.map((role) => (
            <option key={role.id} value={role.id}>{role.name}</option>
          ))}
        </select>
        <button className="submit-btn" onClick={handleAssignRole}>Təyin et</button>
      </div>
    </div>
  );
};

export default RoleAssignModal;